import HTTP from "../../http";

const EMAIL_ENDPOINT = "/email";
const VERIFY_EMAIL_ENDPOINT = "/verifyEmail";

export async function verifyEmail(token) {
  // console.log(token);
  return await HTTP.put(
    EMAIL_ENDPOINT + VERIFY_EMAIL_ENDPOINT,
    { token: token },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
